import { memo, useMemo } from "react";
import LightSwitch from "./LightSwitch";
import type { Light } from "../types";
import icon1 from "../../../assets/images/lighting-icons/1.png";
import icon2 from "../../../assets/images/lighting-icons/2.png";
import icon3 from "../../../assets/images/lighting-icons/3.png";
import icon4 from "../../../assets/images/lighting-icons/4.png";
import icon5 from "../../../assets/images/lighting-icons/5.png";

interface LightingManagerProps {
  lights: Light[];
  onToggle: (id: string) => void;
  title?: string;
  subtitle?: string;
  className?: string;
}

const LightIcon = ({ src }: { src: string }) => (
  <img
    src={src}
    alt=""
    className="w-[18px] h-[18px] object-contain flex-shrink-0"
  />
);

const LIGHT_ICONS: Record<string, React.ReactNode> = {
  headlights: <LightIcon src={icon1} />,
  hazard: <LightIcon src={icon2} />,
  fog: <LightIcon src={icon3} />,
  interior: <LightIcon src={icon4} />,
  ambient: <LightIcon src={icon5} />,
};

const LightingManager = memo<LightingManagerProps>(
  ({
    lights,
    onToggle,
    title = "Lighting Management",
    subtitle = "Window name",
    className = "",
  }) => {
    const switchList = useMemo(
      () =>
        lights.map((light) => (
          <LightSwitch
            key={light.id}
            name={light.name}
            subName={light.subName}
            isOn={light.isOn}
            icon={LIGHT_ICONS[light.id] ?? <LightIcon src={icon1} />}
            onToggle={() => onToggle(light.id)}
          />
        )),
      [lights, onToggle],
    );

    return (
      <div
        className={`flex-shrink-0 flex flex-col rounded-xl p-3 border-[1px] border-white/[0.06] bg-[#0b0c0c]/40 ${className}`}
      >
        <div className="mb-3">
          <h3 className="text-white text-[18px]  leading-tight">{title}</h3>
          <p className="text-white/50 text-[13px] mt-0.5">{subtitle}</p>
        </div>

        <div className="flex flex-col gap-[5px] overflow-y-auto scrollbar-hide">
          {switchList}
        </div>
      </div>
    );
  },
);

LightingManager.displayName = "LightingManager";
export default LightingManager;
